import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import sf from "../assets/sf.jpg";
import ui from "../assets/UI.jpg";
import app from "../assets/app.jpg";
import web from "../assets/web.webp";
import soon from "../assets/commingsoon.jpeg";
import comming from "../assets/commingsoon.jpeg";



// ✅ Section-specific images
const sectionImages = {
  "Web Development": [web],
  "App Development": [app],
  "UI/UX Design": [ui],
  "Software Development": [sf],
  "Home Services": [comming],
  "Real Estate": [soon],
};

const solutions = [
  {
    title: "Software Development",
    content:
      "Custom software solutions to automate workflows and improve efficiency.",
  },
  {
    title: "UI/UX Design",
    content:
      "Creative, user-friendly, and engaging designs that ensure smooth customer interaction.",
  },
  {
    title: "App Development",
    content:
      "Native and cross-platform mobile apps with seamless user experience and performance.",
  },
  {
    title: "Web Development",
    content:
      "We build modern, responsive, and scalable web applications tailored to your business needs.",
  },
  {
    title: "Real Estate",
    content:
      "Digital solutions for real estate listing, management, and property discovery.",
  },
  {
    title: "Home Services",
    content:
      "A platform connecting customers with trusted home service providers.",
  },
];

export default function SolutionsSection() {
  const [activeTab, setActiveTab] = useState(0);
  const activeSection = solutions[activeTab].title;

  return (
    <section className="bg-gray-50 py-12 px-6 md:px-12">
      {/* Heading */}
      <h2 className="text-4xl font-bold text-gray-800 mb-8 text-center">
        Our Solutions
      </h2>

      {/* Menu Bar - Centered, Responsive, Attractive Border */}
        <div className="flex justify-center mb-10 px-2">
        <div className="flex gap-4 p-1 rounded-full border-4 border-gradient-to-r from-orange-400 via-pink-400 to-purple-500 bg-white shadow-lg overflow-x-auto scrollbar-hide">
            {solutions.map((sol, index) => (
            <button
                key={index}
                onClick={() => setActiveTab(index)}
                className={`flex-shrink-0 px-4 sm:px-6 py-2 sm:py-3 rounded-full font-medium transition-all text-sm sm:text-lg ${
                activeTab === index
                    ? "bg-gray-500 border text-white shadow-md"
                    : "bg-white text-gray-800 hover:bg-orange-300"
                }`}
            >
                {sol.title}
            </button>
            ))}
        </div>
        </div>


      {/* Content */}
<div className="mt-10 flex flex-col md:flex-row gap-8 items-center justify-center">
  {/* Image Carousel */}
  <div className="relative w-full md:w-7/12">
    <Swiper
      modules={[Navigation, Autoplay]}
      navigation
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop
      className="rounded-xl shadow-lg border-4 border-gradient-to-r from-orange-400 via-pink-400 to-purple-500"
    >
      {sectionImages[activeSection].map((img, i) => (
        <SwiperSlide key={i}>
          <img
            src={img}
            alt={`${activeSection} Slide ${i + 1}`}
            className="w-full h-72 md:h-[450px] object-cover rounded-xl"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  </div>

  {/* Text Content */}
  <div className="w-full md:w-5/12">
    <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
      {solutions[activeTab].title}
    </h2>
    <p className="text-gray-600 leading-relaxed text-lg">
      {solutions[activeTab].content}
    </p>
  </div>
</div>

    </section>
  );
}
